import React, { PropsWithChildren, ReactNode } from 'react';

import cx from 'classnames';

import useMediaBreakpoints from '../../../hooks/useMediaBreakpoints';
import s from './index.module.css';

interface ILandingBuilderLayoutProps extends PropsWithChildren {
  // table of contents navigation component
  tocNavigationComponent: ReactNode;
  topBarComponent?: ReactNode;
}

const LandingBuilderLayout = ({
  children,
  tocNavigationComponent,
  topBarComponent = null,
}: ILandingBuilderLayoutProps) => {
  const { isTabletOrMobile } = useMediaBreakpoints();

  return (
    <div className={s.wrapper}>
      {!isTabletOrMobile && <div className={s.toc}>{tocNavigationComponent}</div>}
      <div className={cx(s.content, topBarComponent && s.gridView)}>
        {topBarComponent}
        <div className={s.landingContainer}>{children}</div>
      </div>
    </div>
  );
};

export default LandingBuilderLayout;
